module.exports = __webpack_public_path__ + "../static/img/base_ubuntu.fcd88ba2.png";